// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getData = createAsyncThunk('company/getData', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/company/companyList`, {params})
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

export const getCompany = createAsyncThunk('company/getCompany', async id => {
  let response = {}
  if (id > 0) {
    response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/company/companyEdit/${id}`)
    return response.data.Response.item
  } else {
    return response
  }
})

export const addCompany = createAsyncThunk('company/addCompany', async (CreateCompany, { dispatch, getState }) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/company/companyCreate`, {
    Request: {
      CreateCompany
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().companys.params))
  await dispatch(getAllData())
  return CreateCompany
})

export const updateCompany = createAsyncThunk('company/addCompany', async (UpdateCompany, { dispatch, getState }) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/company/companyUpdate`, {
    Request: {
      UpdateCompany
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().companys.params))
  await dispatch(getAllData())
  return UpdateCompany
})

export const changeStatus = createAsyncThunk('company/changeStatus', async (ChangeStatusCompany, { dispatch, getState }) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_API}Schedule/company/companyChangeStatus`, {
    Request: {
      ChangeStatusCompany
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().companys.params))
  return ChangeStatusCompany
})

export const deleteCompany = createAsyncThunk('company/deleteCompany', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_BASE_API}Schedule/company/companyDelete/${id}`)

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().companys.params))
  await dispatch(getAllData())
  return id
})

export const appCategoriesSlice = createSlice({
  name: 'companies',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedCompany: [],
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getCompany.fulfilled, (state, action) => {
        state.selectedCompany = action.payload
      })
  }
})

export default appCategoriesSlice.reducer
